import type {SegmentWidgetConfig, VerticalsWidgetConfig} from '@yandex-delivery/form'

export const segmentMock = {
  widget_id: 'vertical_group_id_wide_segment_widget',
  action: {
    form_state_key: 'vertical_group_id',
    options: [
      {
        selected_text: {
          title: {
            items: [
              {
                type: 'text',
                text: 'По городу',
                font_size: 16,
                color: 'textMain',
              },
            ],
          },
        },
        unselected_text: {
          title: {
            items: [
              {
                type: 'text',
                text: 'По городу',
                font_size: 16,
                color: 'textMinor',
              },
            ],
          },
        },
        value: 1,
        default: true,
        is_available: true,
        accessibility_info: {
          is_header: false,
          content_description: '',
        },
      },
      {
        selected_text: {
          title: {
            items: [
              {
                type: 'text',
                text: 'По России',
                font_size: 16,
                color: 'textMain',
              },
            ],
          },
        },
        unselected_text: {
          title: {
            items: [
              {
                type: 'text',
                text: 'По России',
                font_size: 16,
                color: 'textMinor',
              },
            ],
          },
        },
        value: 2,
        default: false,
        is_available: true,
        accessibility_info: {
          is_header: false,
          content_description: '',
        },
      },
    ],
  },
  type: 'segment',
} as SegmentWidgetConfig

export const verticalsMock = {
  widget_id: 'cargo_c2c_order_forms_b2b_lk_verticals_widget',
  options: [
    {
      value: 'walking_courier',
      title: {
        items: [
          {
            type: 'text',
            text: 'Велокурьер',
            font_size: 16,
            font_weight: 'medium',
            color: 'text',
          },
        ],
      },
      subtitle: {
        items: [
          {
            type: 'text',
            text: 'Для вещей до 10 кг',
            font_size: 11,
            font_weight: 'regular',
            color: 'textMinor',
          },
        ],
      },
      icon: {
        image_tag: 'class_courier_walking_icon_10',
      },
    },
    {
      value: 'express',
      title: {
        items: [
          {
            type: 'text',
            text: 'Экспресс',
            font_size: 16,
            font_weight: 'medium',
            color: 'text',
          },
        ],
      },
      subtitle: {
        items: [
          {
            type: 'text',
            text: 'Срочно или в течение дня',
            font_size: 11,
            color: 'textMinor',
          },
        ],
      },
      icon: {
        image_tag: 'class_express_icon_7_order',
      },
    },
    {
      value: 'cargo',
      title: {
        items: [
          {
            type: 'text',
            text: 'Грузовой',
            font_size: 16,
            font_weight: 'medium',
            color: 'text',
          },
        ],
      },
      subtitle: {
        items: [
          {
            type: 'text',
            text: 'Большой кузов и грузчики',
            font_size: 11,
            color: 'textMinor',
          },
        ],
      },
      icon: {
        image_tag: 'class_cargo_icon_10_order',
      },
    },
    {
      value: 'ndd_self_pickup',
      title: {
        items: [
          {
            type: 'text',
            text: 'Пункт выдачи',
            font_size: 16,
            font_weight: 'medium',
            color: 'text',
          },
        ],
      },
      subtitle: {
        items: [
          {
            type: 'text',
            text: 'Заказ нужно отнести самим',
            font_size: 11,
            color: 'textMinor',
          },
        ],
      },
      icon: {
        image_tag: 'class_ndd_icon_7_order',
      },
    },
    {
      value: 'ndd_shipment',
      title: {
        items: [
          {
            type: 'text',
            text: 'Склад',
            font_size: 16,
            font_weight: 'medium',
            color: 'text',
          },
        ],
      },
      subtitle: {
        items: [
          {
            type: 'text',
            text: 'Заказ заберут с вашего адреса',
            font_size: 11,
            color: 'textMinor',
          },
        ],
      },
      icon: {
        image_tag: 'class_ndd_external_icon_7_order',
      },
    },
  ],
  form_state_key: 'form_state_key',
  type: 'verticals',
} as VerticalsWidgetConfig
